import { NullValueObject } from '@/utils/value-objects/null-value-object.js';

export class NullProbeName extends NullValueObject {}
